export default __webpack_public_path__ + "img/26c6f29cf46913033f1c31d984102e2c.svg";